import { toastService } from '@thefarmersfront/kitchen';

import { registerMockAPI } from '~/mocks/mockApis';

import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { TOAST_MESSAGE } from '~/constants';

/**
 * [입고요청등록] 엑셀 양식 다운로드 API
 */
const fetchRequestGoodsDownloadTemplate = async (ownerCode: string) => {
  const endpoint = '/api-inbound/v1/3pl/receiving';
  const response = await axiosInstance.get(`${endpoint}/${ownerCode}/request/goods/download-template`, {
    responseType: 'blob',
  });
  downloadBlobDataFile(response);
};

/**
 * [입고요청등록] 엑셀 양식 다운로드 Mutation Hook
 */
export const useGetRequestGoodsDownloadTemplateMutation = () => {
  return useDownloadMutation(fetchRequestGoodsDownloadTemplate, {
    onSuccess: () => {
      toastService.addToast({ message: TOAST_MESSAGE.DOWNLOAD_SUCCESS });
    },
    // 에러는 전역 핸들러에서 처리
  });
};

registerMockAPI<null>({
  method: 'get',
  endpoint: '/api-inbound/v1/3pl/receiving/:ownerCode/request/goods/download-template',
  label: '입고/입고요청/템플릿다운로드',
  scenarios: [
    { name: '정상 응답', response: null },
    {
      name: '서버 오류',
      response: { error: { message: '템플릿 다운로드 중 오류가 발생했습니다.' } },
      status: 500,
    },
  ],
});
